<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" lg="12">
          <logout></logout>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import logout from "@/components/usuario/LogoutComponent.vue";

export default {
  data() {
    return {};
  },
  components: {
    logout,
  },
};
</script>